// extracted by mini-css-extract-plugin
export default {"achievementsMobile":"achievementsMobile_YRULk","title":"title_Ljg6U","count":"count_hwGSx","arrowIcon":"arrowIcon_YW7vO"};